import { FETCH_LANGUAGES_FAILURE, FETCH_LANGUAGES_SUCCESS } from 'constants/ActionTypes';
import { FETCH_TRANSLATIONS_FAILURE, FETCH_TRANSLATIONS_SUCCESS } from 'modules/i18n/actionTypes';
import { CURRENT_USER_DATA_FAILURE, CURRENT_USER_DATA_SUCCESS } from 'modules/users/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const READY_ACTIONS = [
  FETCH_LANGUAGES_FAILURE,
  CURRENT_USER_DATA_FAILURE,
  FETCH_TRANSLATIONS_FAILURE,
  FETCH_LANGUAGES_SUCCESS,
  CURRENT_USER_DATA_SUCCESS,
  FETCH_TRANSLATIONS_SUCCESS,
];

export default createReducer(null, undefined, [
  {
    matcher: ({ type }) => READY_ACTIONS.includes(type),
    reducer: () => true,
  },
]);
